import * as React from 'react';
import {
  SearchableListItem,
  SearchableListItemBody,
  SearchableListItemActions,
  SearchableListItemAdornment,
  Tooltip,
  HomeIcon,
  OptionType,
} from '@packages/systems/spring';
import {FilePathTooltip, getPageAutomationId, getPageIcon} from './utils';
import {ExtraPageOptionType} from './types';

type PageOptionProps = {
  option: OptionType & ExtraPageOptionType;
};

export const PageOption = ({option}: PageOptionProps) => {
  const textColorVariant = option.pageType === 'draft' ? 'orange' : undefined;

  return (
    <SearchableListItem
      data-automation-id={getPageAutomationId(option.label)}
      prefix={getPageIcon(option.pageType)}
      textColorVariant={textColorVariant}
    >
      <SearchableListItemBody
        description={
          option.ancestry &&
          option.ancestry.length > 0 && (
            <FilePathTooltip path={option.ancestry || []} isDisabled={false} />
          )
        }
        truncationTooltipProps={{
          description: {shouldNotShowTooltip: true},
        }}
      >
        {option.label}
      </SearchableListItemBody>
      <SearchableListItemActions>
        {option.pageType === 'homepage' && (
          <SearchableListItemAdornment isInteractive>
            <Tooltip asChild content="This is the current homepage">
              <HomeIcon
                density="comfortable"
                tabIndex={-1}
                colorVariant="secondary"
              />
            </Tooltip>
          </SearchableListItemAdornment>
        )}
      </SearchableListItemActions>
    </SearchableListItem>
  );
};

export default PageOption;
